import { Controller } from "@hotwired/stimulus"

// Auto-formats CPF (000.000.000-00) and RG (00.000.000-0) as the user
// types. Each "9" in the pattern is a digit slot; any other character is
// inserted literally — add a new key here if another document format is
// ever needed.
const PATTERNS = {
  cpf: "999.999.999-99",
  rg: "99.999.999-9"
}

export default class extends Controller {
  static values = { type: String }

  format(event) {
    const pattern = PATTERNS[this.typeValue]
    if (!pattern) return

    const input = event.target
    const previousLength = input.value.length
    const cursorPosition = input.selectionStart

    const digitCount = pattern.split("").filter((char) => char === "9").length
    const digits = input.value.replace(/\D/g, "").slice(0, digitCount)

    let formatted = ""
    let digitIndex = 0
    for (const char of pattern) {
      if (digitIndex >= digits.length) break
      if (char === "9") {
        formatted += digits[digitIndex]
        digitIndex++
      } else {
        formatted += char
      }
    }

    input.value = formatted

    const newPosition = Math.max(0, cursorPosition + (formatted.length - previousLength))
    input.setSelectionRange(newPosition, newPosition)
  }
}
